import * as signalR from '@microsoft/signalr';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SignalRService {
  private hubConnection!: signalR.HubConnection;

  async startConnection(): Promise<string> {
    if (this.hubConnection?.state === signalR.HubConnectionState.Connected) {
      return this.hubConnection.connectionId!;
    }

    // For Package Installer dynamic protocol and host of BE
     this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(`${window.location.protocol}//${window.location.host}/scriptExecutionHub`)
    .withAutomaticReconnect()
    .build();

    await this.hubConnection.start();

    return this.hubConnection.connectionId!;
  }

  onMessage(callback: (message: string) => void) {
    // Remove previous listeners (important!)
    this.hubConnection.off('ReceiveScriptMessage');

    this.hubConnection.on('ReceiveScriptMessage', (message: string) => {
      callback(message);
    });
  }

  stopConnection() {
    if (this.hubConnection) {
      this.hubConnection.stop();
    }
  }
}
